import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
// import { Helmet } from "react-helmet";
import logoImage from "../assest/images/logo-img.png"

const PageTitle = ({
    title = "toursxplorer",
    metaTitle = "toursxplorer",
    metaKeyword = "toursxplorer",
    metaDescription = "toursxplorer.com is an Online Travel Agency (OTA) based in Lisbon, Portugal",
    script = "",
    image = ""
}) => {

    useEffect(() => {
        document.title = metaTitle;
    }, [metaTitle]);


    return (
        <Helmet>
            <meta charSet="utf-8" />
            <title>{title}</title>
            <meta name="title" content={metaTitle} />
            <meta name="keywords" content={metaKeyword} />
            <meta name="description" content={metaDescription} />
            <link rel="canonical" href={window.location?.origin + window.location?.pathname} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={image} />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@Tours_xplorer" />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={image} />
            {script}
        </Helmet>
    )
}
export default PageTitle;